import { render, staticRenderFns } from "./TopWordsPublicDisplayItem.vue?vue&type=template&id=ddbbad7c&scoped=true"
import script from "./TopWordsPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./TopWordsPublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./TopWordsPublicDisplayItem.vue?vue&type=style&index=0&id=ddbbad7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbbad7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbbad7c')) {
      api.createRecord('ddbbad7c', component.options)
    } else {
      api.reload('ddbbad7c', component.options)
    }
    module.hot.accept("./TopWordsPublicDisplayItem.vue?vue&type=template&id=ddbbad7c&scoped=true", function () {
      api.rerender('ddbbad7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/TopWordsPublicDisplayItem.vue"
export default component.exports